import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { E } from '@angular/core/src/render3';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import html2canvas from './html2canvas.min.js';
declare let $, d3;

@Component({
  selector: 'app-model-show',
  templateUrl: './model-show.component.html',
  styleUrls: ['./model-show.component.css']
})
export class ModelShowComponent implements OnInit {
  @Input() modelParam: any = null;    // 模型版本id
  @Input() refreshState: any = null;    // 刷新
  @Input() showLeft:any = null;    // 左侧数据模型树是否展示
  @Input() isRecordVersion: any = null;    // 是否为历史模型版本
  @Input() userRole: string = null;        // 当前用户角色
  // 点击编辑、查看、删除、复制、关系配置、元数据配置等功能按钮后向父组件发射数据
  @Output('toolbarBtnClick') toolbarBtnClick = new EventEmitter<any>();  
  container = null;    //容器svg>g
  duration = 750;      //动画持续时间
  scaleRange = [.2, 4];    //container缩放范围
  direction = ['r'];  //分为左右2个方向
  centralPoint = [0, 0];   //画布中心点坐标x,y
  root:any = {r: {}, l: {}};   //左右2块数据源
  rootNodeLength = 0;      //根节点名称长度
  textSpace = 15;          //多行文字间距
  themeColor = "#83302E";  //主色
  nodeSize = [50, 180];    //节点间距(高/水平)
  fontSize = 14;           //字体大小，也是单字所占宽高
  rectWidth = 125;          //节点方框默认宽度
  circleR = 5;             //圆圈半径
  treeData:any = {'r': {}, 'l': {}};       //当前展示的树数据
  conceptData:any = [];       //概念树数据
  attrData:any = [];         //属性树数据 
  state = 0;               //0:查看概念树；1:查看属性树
  clickNodeTimeout:any = null;    //鼠标单击定时器
  isLoading:boolean = false;   // 是否正在请求数据
  conceptName:string = '';  // 当前正在查看元数据的概念名称
  conceptId:string = '';  // 当前正在查看元数据的概念id
  isHorizontal = true;   // true:展示模型可视化组件；false:展示概念树组件
  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
    $('#treeContainer').bind('contextmenu',function(e){ return false; });
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    // 判断左侧数据模型树是否折叠或展开，若有，则需要重新获取svg画布的宽度
    if(changes['showLeft'] && $('#treeContainer').html()){
      const margin = {top: 0, right: 5, bottom: 0, left: 0};
      const treeWidth = $('#treeContainer').width() - margin.left - margin.right;//tree容器宽
      d3.select('.tree-svg').attr('width', treeWidth);
    }else{
      let loadConceptTree = false;
      // 判断模型版本id是否发生变化，发生变化则应重新加载概念树
      if(changes['modelParam']){
        let obj = changes['modelParam'];
        // 判断模型版本id是否发生变化
        if(obj['currentValue'] && obj['previousValue'] && obj['currentValue']['id'] != obj['previousValue']['id']){
          loadConceptTree = true;
        }
      }
      if(this.modelParam && this.modelParam.id){
        // 模型版本id发生变化，则应重新加载概念树
        if(loadConceptTree){
          // 根据模型版本id查询概念信息
          this.getOnlogyTreePageList();
        }
        // 否则，按照state的值确定加载概念树、属性树
        else{
          if(this.state === 0){
            // 根据模型版本id查询概念信息
            this.getOnlogyTreePageList();
          }else{
            // 根据模型版本id、概念id查询属性信息
            this.getAttrTreePageList();
          }
        }
      }
      this.isHorizontal = true;
    }
  }

  // 请求概念数据模型方法
  getOnlogyTreePageList() {
    // 根据模型版本id查询概念数据
    this.isLoading = true;
    this.kmsService.getConceptTree(this.modelParam.id).subscribe(
        result => {
            if (result.code == 200) {
                this.isLoading = false;
                let datas = result.data;
                if(datas){
                  this.conceptData = JSON.parse(JSON.stringify(datas));
                  // 将概念信息转化成树图数据格式
                  this.treeData.r = {
                    'id': this.modelParam.id,
                    'name': this.modelParam.modelName + this.modelParam.name,
                    'type': 1,  // 1 模型  2 概念  3 属性
                    'belongConceptId': '',  // 仅对属性节点起作用
                    'primaryKey': null,
                    'children': []
                  }
                  this.getChilds(this.modelParam.id, datas, this.treeData.r,true);
                  this.state = 0;
                  // 清空图谱
                  d3.select('svg.tree-svg').remove();
                  // 绘制树图
                  this.treeInit();
                }
            } else {
                this.message.waring(result.msg);
            }
        }
    )
  }

  getChilds(id, datas, obj,isConceptTree){
    let items = datas.filter(el => el.pid == id);
    if(items.length>0){
      items.forEach(el => {
        obj.children.push({
          'id': el.id,
          'name': el.name,
          'type': isConceptTree ? 2 : el.type,
          'belongConceptId': el.type === 3 ? el.conceptId : '',
          'primaryKey': el.primaryKey,
          'children': []
        });
        let obj1 = obj.children[obj.children.length - 1];
        this.getChilds(el.id, datas, obj1,isConceptTree);
      })
    }
  }

  //树布局
  treeMap() {
    return d3.tree().nodeSize(this.nodeSize).separation((a, b) => {
      let result = a.parent === b.parent && !a.children && !b.children ? 1 : 2;
      if (result > 1) {
        let length = 0;
        length = a.children ? (length + a.children.length) : length;
        length = b.children ? (length + b.children.length) : length;
        result = length / 2 + 0.5;
      }
      return result;
    });
  }

  //初始化
  treeInit() {
    const margin = {top: 0, right: 5, bottom: 0, left: 0};
    const treeWidth = $('#treeContainer').width() - margin.left - margin.right;//tree容器宽
    const treeHeight = $('#treeContainer').height() - margin.top - margin.bottom;//tree容器高
    const centralY = treeWidth / 5 + margin.left;
    const centralX = treeHeight / 2 + margin.top;
    this.centralPoint = [centralX, centralY];//中心点坐标
    //根节点字符所占宽度
    this.rootNodeLength = 7 * this.fontSize + 30;

    //svg标签
    const svg = d3.select('#treeContainer').append('svg')
      .attr('class', 'tree-svg')
      .attr('width', treeWidth)
      .attr('height', treeHeight)
      .attr('font-size', this.fontSize)
      .attr('fill', '#555');

    //g标签
    this.container = svg.append('g')
      .attr('id','treeContainerG')
      .attr('class', "container");
    //画出根节点
    this.drawRoot();

    //指定缩放范围
    const zoom = d3.zoom().scaleExtent(this.scaleRange).on('zoom', this.zoomFn);
    //动画持续时间
    this.container.transition().call(zoom.transform, d3.zoomIdentity);
    svg.call(zoom).on('dblclick.zoom',null);    // 取消双击放大事件;
    //数据处理
    this.dealData();
  };
  //初始化缩放方法
  zoomFn() {
    const zoom = d3.event.transform;
    return d3.select('g.container').attr("transform", zoom);
  };
  //数据处理
  dealData() {
    this.direction.forEach(item => {
      this.root[item] = d3.hierarchy(this.treeData[item]);
      this.root[item].x0 = this.centralPoint[0];//根节点x坐标
      this.root[item].y0 = this.centralPoint[1];//根节点Y坐标
      this.root[item].descendants().forEach(d => {
        d._children = d.children;//添加_children属性，用于实现点击收缩及展开功能
        // // 默认只展开一级
        // if(d.depth > 0){
        //   d.children = null;
        // }
        d.id = d.data.id;//绑定唯一标识ID
      });
      this.update(this.root[item], item);
    })
  };
  //画根节点
  drawRoot() {
    let rootName = [];
    let nameStr = this.treeData.r.name;
    let rootLen = nameStr.length;
    if(rootLen<=10){
      rootName= [nameStr]
    }else{
      let str1 = nameStr.slice(0,8);
      let str2 = nameStr.slice(8);
      rootName= [str1,str2];
    }
    const title = this.container.append('g')
      .attr('id', "rootTitle")
      .attr("transform", `translate(${this.centralPoint[1]+this.rootNodeLength/2},${this.centralPoint[0]})`);
    title.append('svg:rect')
      .attr('class', "rootTitle")
      .attr("y", 0)
      .attr("x", -this.rootNodeLength / 2)
      .attr("width", this.rootNodeLength)
      .attr("height", 0)
      .attr("rx", 5) //圆角
      .style('fill', this.themeColor);
    rootName.forEach((name, index) => {
      title.append('text').attr('fill', 'white')
        .attr('y', d => {
          if(rootName.length == 1){
            return index * this.textSpace + 5;
          }else{
            return index * this.textSpace - 2;
          }
        })
        .attr('text-anchor', 'middle')
        .text(name);
      let lineHeight = rootName.length == 1 ? 45 : (index + 2) * this.textSpace;
      //修改rootTitle rect 的高度
      d3.select('#rootTitle rect').attr('height', lineHeight).attr('y', -lineHeight / 2);
    });
  };

  //开始绘图
  update(source, direction) {
    const dirRight = direction === 'r' ? 1 : -1;//方向为右/左
    const className = `${direction}gNode`;
    const treeObj = this.treeMap();
    const tree = treeObj(this.root[direction]);
    let nodes = tree.descendants();//返回后代节点数组，第一个节点为自身，然后依次为所有子节点的拓扑排序
    const links = tree.links();//返回当前 node 的 links 数组, 其中每个 link 定义了 source父节点, target 子节点属性。
    nodes.forEach(d => {
      //左右2部分，设置以中心点为圆点(默认左上角为远点)
      d.y = dirRight * (d.y + this.rootNodeLength / 2) + this.centralPoint[1];
      d.x = d.x + this.centralPoint[0];
    });

    //根据class名称获取左或者右的g节点，达到分块更新
    //将节点按照深度由大到小排序（使绘制时先绘制子节点再绘制父节点，避免右键菜单被遮挡）
    nodes = nodes.sort((a,b) => {return b.depth - a.depth});
    const node = this.container.selectAll(`g.${className}`).data(nodes, d => d.id);

    //新增节点，tree会根据数据内的children扩展相关节点
    const nodeEnter = node.enter().append("g")
      .attr('cursor', d => {  
        // // 查看属性树时，模型节点和概念节点不可点击
        // if(d.data.type != 3 && this.state === 1){
        //   return 'initial'
        // }
        // // 查看属性树时，继承的属性念节点不可点击
        // else if(d.data.type === 3 && this.state === 1){
        //   return d.data.belongConceptId === this.conceptId  ? 'pointer' : 'initial';
        // }else{
        //   return 'pointer';
        // }
        return d.data.type == 1 ? 'initial' : 'pointer';
      })
      .attr('id', d => `node_${d.id}`)
      .attr('class', className)
      .attr("transform", d => `translate(${source.y0},${source.x0})`)
      .attr("fill-opacity", 0)
      .attr("stroke-opacity", 0)
      .on("mousedown", (d) => {
        this.clickNode(d);
      })
      .on("dblclick", d => {
        this.dblClickNode(d);
      });

    nodeEnter.each(d => {
      if (d.depth > 0 && !d._children) {//非根节点且无子节点
        this.drawText(`node_${d.id}`, dirRight);//画文本
        this.drawRect(`node_${d.id}`, dirRight);//画方框
        // this.drawFilter(`node_${d.id}`);//画阴影
        // d3.select(`#node_${d.id} rect`).attr('stroke-width',15).attr('filter',`url(#fg${d.id})`);//给rect绑定阴影
      }
      if (d.depth > 0 && d._children) {//非根节点且有子节点
        this.drawText(`node_${d.id}`, dirRight);//画文本
        this.drawRect(`node_${d.id}`, dirRight);//画方框
        this.drawCircle(`node_${d.id}`,direction);//画圆圈
      }
      this.drawTitle(`node_${d.id}`,direction);   //画文字显示不完整时的提示
      if(d.data.type !== 1){
        this.drawMenu(`node_${d.id}`,d.data.type);     //画右键菜单
      }
    });

    // 更新节点：节点enter和exit时都会触发tree更新
    const nodeUpdate = node.merge(nodeEnter).transition().duration(this.duration)
      .attr("transform", d => `translate(${d.y - dirRight * this.rectWidth / 2},${d.x})`)
      .attr("fill-opacity", 1)
      .attr("stroke-opacity", 1);

    // 移除节点:tree移除掉数据内不包含的节点(即，children = false)
    const nodeExit = node.exit().transition().duration(this.duration).remove()
      .attr("transform", d => `translate(${source.y};${source.x})`)
      .attr("fill-opacity", 0)
      .attr("stroke-opacity", 0);


    // Update the links 根据 className来实现分块更新
    const link = this.container.selectAll(`path.${className}`).data(links, d => d.target.id);

    // Enter any new links at the parent's previous position.
    //insert是在g标签前面插入，防止连接线挡住G节点内容
    const linkEnter = link.enter().insert("path", 'g')
      .attr('class', className)
      .attr("d", d => {
        const o = {x: source.x0, y: source.y0, data: source.data};
        return this.diagonal({source: o, target: o});
      })
      .attr("fill", 'none')
      .attr("stroke-width", 1)
      .attr('stroke', '#dddddd');

    // Transition links to their new position.
    link.merge(linkEnter).transition().duration(this.duration).attr("d", this.diagonal);

    // Transition exiting nodes to the parent's new position.
    link.exit().transition().duration(this.duration).remove()
      .attr("d", d => {
        const o = {x: source.x, y: source.y, data: source.data};
        return this.diagonal({source: o, target: o});
      });

    // Stash the old positions for transition.
    this.root[direction].eachBefore(d => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
  };

  //画连接线
  diagonal({source, target}) {
    let s = source, t = target;
    let sy = s.y;
    let ty = t.y;
    if(source.data.type !== 1){
      sy += 50;
      ty += 50;
    }else{
      ty += 50;
    }
    return `M ${sy} ${s.x}
            L ${(sy + ty) / 2} ${s.x},
            L ${(sy + ty) / 2} ${t.x},
            ${ty} ${t.x}`
  };

  //画文本
  drawText(id, dirRight) {
    dirRight = dirRight > 0;//右为1，左为-1
    return d3.select(`#${id}`).append("text")
      .attr('y', 5)
      .attr("x", d => {
        return 65;
        // let str = d.data.name;
        // if(str.length > 7){
        //   return 65;
        // }else{
        //   const x = (this.rectWidth - str.length*this.fontSize)/2+(this.rectWidth/2 - 5);
        //   return x;
        // }
      })
      .attr('text-anchor', dirRight ? 'start' : 'end')
      .style('font-size', this.fontSize)
      .text(d => {
        let str = d.data.name;
        // 使用正则表达式判断是否全为中文
        const chineseRegex = /^[\u4e00-\u9fa5\/\-_]+$/;
        const maxLen = chineseRegex.test(str) ? 7 : 13;
        if(str.length <= maxLen){
          return str;
        }else{
          return str.slice(0,maxLen)+'...'
        }
      })
      .attr('fill', d => this.getTextColor(d.data.belongConceptId,d.data.type));
  };

  //画方框阴影
  drawFilter(id) {
    return d3.select(`#${id}`).insert('defs', 'rect').append('filter')
      .attr('id', `f${id}`).attr('x', 0).attr('y', 0).append('feGaussianBlur')
      .attr('in', 'SourceGraphic').attr('stdDeviation', '5');
  };

  //画方框
  drawRect(id, dirRight) {
    return d3.select(`#${id}`).insert('rect', 'text')
      .attr('x', d => {
        return dirRight > 0 ? 0+(this.rectWidth/2 - 5) : -this.rectWidth-(this.rectWidth/2 - 5);
      })
      .attr('y', -15)
      .attr("width", this.rectWidth)
      .attr("height", 30)
      .attr("rx", d => {
        return d.data.type === 2 ? 2 : 15
      }) //圆角
      .attr("fill", d => {
        // 查看属性树，模型及概念节点添加不可点击样式
        if(d.data.type != 3 && this.state === 1){
          return '#eeeeee';
        }
        // 查看属性树，继承的属性节点添加不可点击样式
        if(d.data.type === 3 && this.state === 1){
          if(d.data.belongConceptId !== this.conceptId){
            return '#eeeeee';
          }
        }
        return '#ffffff';
      })
      .style('stroke', d => this.getRectStorke(d.data.belongConceptId,d.data.type));
  };

  //画circle
  drawCircle(id,direction) {
    let gMark = d3.select(`#${id}`).append('g')
      .attr('class', 'node-circle')
      .attr("stroke", "#787878")
      .attr('stroke-width', 1)
      .attr('transform','translate(185,0)')
      .attr('cursor','pointer')
      .on("click", (d) => {
        d.depth !== 0 && this.clickShrinkOrExpand(d, direction);//根节点不执行点击事件
      });

    gMark.append("circle")
      .attr('fill', 'none')
      .attr("r", d => d.depth === 0 ? 0 : this.circleR)//根节点不设置圆圈
      .attr('fill', '#ffffff');
    let padding = this.circleR - 2;
    gMark.append('path').attr('d', `m -${padding} 0 l ${2 * padding} 0`);//横线

    gMark.append('path')//竖线，根据展开/收缩动态控制显示
      .attr('d', `m 0 -${padding} l 0 ${2 * padding}`)
      .attr('stroke-width', d => {
        return d.children ? 0 : 1;
      })
      .attr('class', 'node-circle-vertical');
    return gMark
  };

  //画文字显示不完整时的提示
  drawTitle(id, dirRight) {
    return d3.select(`#${id}`).insert('title')
      .text(d => {
        return d.data.name;
      });
  };

  //画节点右键菜单
  drawMenu(id, type) {
    // 仅支持知识库管理员对最新的模型版本进行编辑、删除、复制操作
    let isDisable = false;
    if(this.userRole != '知识库管理员' || this.isRecordVersion){
      isDisable = true;
    }
    let gMark = d3.select(`#${id}`).append('g')
      .attr('class', 'nodeMenu')
      .attr("stroke", "#dedede")
      .attr('stroke-width', 1)
      .attr('transform','translate(150,-16)')
      // .attr('transform','translate(0,-50)')
      .attr('cursor','pointer')
      .attr('display','none');
    // 如果当前节点为概念节点
    if(type === 2){
      gMark.append("rect")
        .attr('width', 190)
        .attr('height',30)
        .attr('fill','#ffffff')
        .attr('stoke','#dedede');
      let editIcon = gMark.append('g')
      editIcon.append('title').text('编辑')
      editIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',10)
            .attr('y',6)
            .attr('xlink:href',d => {
              if(isDisable){
                return '/assets/kgs/img/modify_disabled.svg';
              }else{
                return '/assets/kgs/img/modify.svg';
              }
            })
            .on('mousedown',d=>{
              if(!isDisable){
                this.nodeMenuClick(id,type,'editConcept');
              }
              d3.event.stopPropagation();
            });
      let viewIcon = gMark.append('g')
      viewIcon.append('title').text('查看')
      viewIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',40)
            .attr('y',6)
            .attr('xlink:href','/assets/kgs/img/look.svg')
            .on('mousedown',d=>{
              this.nodeMenuClick(id,type,'conceptView');
              d3.event.stopPropagation();
            });
      let deleteIcon = gMark.append('g')
      deleteIcon.append('title').text('删除')
      deleteIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',70)
            .attr('y',6)
            .attr('xlink:href',d => {
              if(isDisable){
                return '/assets/kgs/img/delete_disabled.svg';
              }else{
                return '/assets/kgs/img/delete.svg';
              }
            })
            .on('mousedown',d=>{
              if(!isDisable){
                this.nodeMenuClick(id,type,'deleteConcept');
              }
              d3.event.stopPropagation();
            });
      let copyIcon = gMark.append('g')
      copyIcon.append('title').text('复制')
      copyIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',100)
            .attr('y',6)
            .attr('xlink:href',d => {
              if(isDisable){
                return '/assets/kgs/img/copy_disabled.svg';
              }else{
                return '/assets/kgs/img/copy.svg';
              }
            })
            .on('mousedown',d=>{
              if(!isDisable){
                this.nodeMenuClick(id,type,'copyConcept');
              }
              d3.event.stopPropagation();
            });
      let attrIcon = gMark.append('g')
      attrIcon.append('title').text('元数据配置')
      attrIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',130)
            .attr('y',6)
            .attr('xlink:href','/assets/kgs/img/attr.svg')
            .on('mousedown',d=>{
              this.nodeMenuClick(id,type,'attrConfig');
              d3.event.stopPropagation();
            });
      let relationIcon = gMark.append('g')
      relationIcon.append('title').text('关系配置')
      relationIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',160)
            .attr('y',6)
            .attr('xlink:href','/assets/kgs/img/relation.svg')
            .on('mousedown',d=>{
              this.nodeMenuClick(id,type,'relationConfig');
              d3.event.stopPropagation();
            });
    }
    // 如果当前节点为属性节点
    else if(type === 3){
      // 判断当前节点是否为复合属性,是，则多加一个添加字段的操作
      let nodeId = id.slice(5);
      let attr = this.getDetatilById(nodeId,'attr');
      gMark.append("rect")
        .attr('width', d => {
          return attr.isCompound ? 128 : 95
        })
        .attr('height',30)
        .attr('fill','#ffffff')
        .attr('stoke','#dedede');
      let editIcon = gMark.append('g')
      editIcon.append('title').text('编辑')
      editIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',10)
            .attr('y',6)
            .attr('xlink:href',d => {
              if(isDisable){
                return '/assets/kgs/img/modify_disabled.svg';
              }else{
                return '/assets/kgs/img/modify.svg';
              }
            })
            .on('mousedown',d=>{
              if(!isDisable){
                this.nodeMenuClick(id,type,'editAttr');
              }
              d3.event.stopPropagation();
            });
      let viewIcon = gMark.append('g')
      viewIcon.append('title').text('查看')
      viewIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',40)
            .attr('y',6)
            .attr('xlink:href','/assets/kgs/img/look.svg')
            .on('mousedown',d=>{
              this.nodeMenuClick(id,type,'attrView');
              d3.event.stopPropagation();
            });
      let deleteIcon = gMark.append('g')
      deleteIcon.append('title').text('删除')
      deleteIcon.append("image")
            .attr('width',18)
            .attr('height',18)
            .attr('x',70)
            .attr('y',6)
            .attr('xlink:href',d => {
              if(isDisable){
                return '/assets/kgs/img/delete_disabled.svg';
              }else{
                return '/assets/kgs/img/delete.svg';
              }
            })
            .on('mousedown',d=>{
              if(!isDisable){
                this.nodeMenuClick(id,type,'deleteAttr');
              }
              d3.event.stopPropagation();
            });
      if(attr.isCompound){
        let addIcon = gMark.append('g')
        addIcon.append('title').text('添加子属性')
        addIcon.append("image")
              .attr('width',18)
              .attr('height',18)
              .attr('x',100)
              .attr('y',6)
              .attr('xlink:href',d => {
                if(isDisable){
                  return '/assets/kgs/img/add_disabled.svg';
                }else{
                  return '/assets/kgs/img/add.svg';
                }
              })
              .on('mousedown',d=>{
                if(!isDisable){
                  this.nodeMenuClick(id,type,'addField');
                }
                d3.event.stopPropagation();
              });
      }
    }
  };

  //点击收缩或展开按钮
  clickShrinkOrExpand(d, direction) {
    if (!d._children && !d.children) {//无子节点
      return;
    }
    //根据当前节点是否有children来判断是展开还是收缩，true收缩，false展开
    //tree会根据节点内是否有children来向下扩展
    d.children = d.children ? null : d._children;
    d3.select(`#node_${d.id} .node-circle .node-circle-vertical`)
      .transition().duration(this.duration)
      .attr('stroke-width', d.children ? 0 : 1);//控制节点伸缩时的标识圆圈
    this.update(d, direction);
  };

  //文本颜色配置
  getTextColor(belongConceptId,type) {
    // 查看属性树，模型及概念节点添加不可点击样式
    if(type != 3 && this.state === 1){
      return '#999999';
    }
    // 查看属性树，继承的属性节点添加不可点击样式
    if(type === 3 && this.state === 1){
      if(belongConceptId !== this.conceptId){
        return '#999999';
      }
    }
    switch (type) {
      case 2:
        return '#DF7266';
      case 3:
        return '#9964F0';
      default:
        return '#999999';
    }
  };
  
  //边框颜色
  getRectStorke(belongConceptId,type) {
    // 查看属性树，模型及概念节点添加不可点击样式
    if(type != 3 && this.state === 1){
      return '#cdcdcd';
    }
    // 查看属性树，继承的属性节点添加不可点击样式
    if(type === 3 && this.state === 1){
      if(belongConceptId !== this.conceptId){
        return '#cdcdcd';
      }
    }
    switch (type) {
      case 2:
        return '#DF7266';
      case 3:
        return '#9964F0';
      default:
        return '#cdcdcd';
    }
  };

  // 给节点绑定单击事件
  clickNode(d){
    const button = d3.event.button;
    clearTimeout(this.clickNodeTimeout);
    this.clickNodeTimeout = setTimeout(()=>{
      // 左键单击
      if(button == 0){
        // 单击概念节点
        if(d.data.type === 2){
          // 进入节点编辑或查看模块
          d3.select('.rgNode.active .nodeMenu').attr('display','none');
          d3.select('.rgNode.active').attr('class','rgNode');
          d3.select('#node_'+d.id).attr('class','rgNode active');
          this.nodeMenuClick(`node_${d.id}`,d.data.type,'conceptView');
        }
        // 单击属性节点
        if(d.data.type === 3){
          // 进入节点编辑或查看模块
          d3.select('.rgNode.active .nodeMenu').attr('display','none');
          d3.select('.rgNode.active').attr('class','rgNode');
          d3.select('#node_'+d.id).attr('class','rgNode active');
          this.nodeMenuClick(`node_${d.id}`,d.data.type,'attrView');
        }
      }

      // 点击概念节点
      if(d.data.type === 2 && this.state === 0){
        // 给当前点击的节点添加选中样式，并移除之前选中节点的选中样式
        d3.select('.rgNode.active .nodeMenu').attr('display','none');
        d3.select('.rgNode.active').attr('class','rgNode');
        d3.select('#node_'+d.id).attr('class','rgNode active');
        // // 左键单击
        // if(button == 0){
        //   // 进入节点编辑或查看模块
        //   this.nodeMenuClick(`node_${d.id}`,d.data.type,'conceptView');
        // }
        // 右键单击
        if(button == 2){
          // 设置其他节点的快捷菜单隐藏，当前节点的显示
          d3.select('#node_'+d.id+' .nodeMenu').attr('display','block');
        }
      }
      // 点击属性节点
      else if(d.data.type === 3 && this.state === 1){
        // 非继承的属性节点才可进行相关操作
        if(d.data.belongConceptId === this.conceptId){
          // 给当前点击的节点添加选中样式，并移除之前选中节点的选中样式
          d3.select('.rgNode.active .nodeMenu').attr('display','none');
          d3.select('.rgNode.active').attr('class','rgNode');
          d3.select('#node_'+d.id).attr('class','rgNode active');
          // // 左键单击
          // if(button == 0){
          //   // 进入节点编辑或查看模块
          //   this.nodeMenuClick(`node_${d.id}`,d.data.type,'attrView');
          // }
          // 右键单击
          if(button == 2){
            // 设置其他节点的快捷菜单隐藏，当前节点的显示
            d3.select('#node_'+d.id+' .nodeMenu').attr('display','block');
          }
        }
      }
    },200);
  }

  // 给概念节点绑定双击事件
  dblClickNode(d){
    clearTimeout(this.clickNodeTimeout);
    if(d.data.type === 2 && this.state === 0){
      // 向父组件发射数据，修改右侧操作栏
      this.toolbarBtnClick.emit({
        state: 'attrConfig',
        selectConcept: this.getDetatilById(d.data.id,'concept')
      });
      // 加载选中概念的元数据配置
      this.conceptId = d.data.id;
      this.getAttrTreePageList();
    }
  }

  // 概念节点右键菜单点击事件  id:node_+概念/属性主键id   type: 1 模型  2 概念  3 属性  state:edit view delete copy ....
  nodeMenuClick(id,type,state) {
    let nodeId = id.slice(5);
    // 隐藏右键菜单
    d3.select('.rgNode.active .nodeMenu').attr('display','none');
    // 概念节点相关操作
    if(type === 2){
      this.toolbarBtnClick.emit({
        state: state,
        selectConcept: this.getDetatilById(nodeId,'concept')
      });
      // 点击元数据配置按钮，需将当前页面切换到元数据配置页面
      if(state == 'attrConfig'){
        this.conceptId = nodeId;
        this.getAttrTreePageList();
      }
    }
    // 属性节点相关操作
    if(type === 3){
      let attr = this.getDetatilById(nodeId,'attr');
      if(state == 'editAttr' || state == 'attrView'){
        // 根据当前属性的父节点是概念节点还是属性节点判断该属性是一级属性，还是二级属性（字段）
        let item = this.attrData.filter(el => el.id == attr.parentId);
        if(item[0].type === 2){
          this.toolbarBtnClick.emit({
            state: state == 'editAttr' ? 'editAttr': 'attrView',
            selectAttr: attr
          });
        }else{
          let parent = this.getDetatilById(attr.parentId,'attr');
          this.toolbarBtnClick.emit({
            state: state == 'editAttr' ? 'editField': 'fieldView',
            selectAttr: parent,
            selectField: attr
          });
        }
      }else{
        this.toolbarBtnClick.emit({
          state: state,
          selectAttr: attr
        });
      }
    }
  };

  // 根据概念id查询元数据信息方法
  getAttrTreePageList() {
    this.isLoading = true;
    // 根据概念节点id获取节点名称
    let items = this.conceptData.filter(el => el.id == this.conceptId);
    this.conceptName = items[0].name;
    // 根据模型版本id查询概念数据
    const params = {
      "conceptId": this.conceptId,
      "modelVerId": this.modelParam.id,
    }
    this.kmsService.queryeAttrTreeList(params).subscribe(
        result => {
            if (result.code == 200) {
                this.isLoading = false;
                let datas = result.data;
                if(datas){
                  this.attrData = JSON.parse(JSON.stringify(datas));
                  // 将概念信息转化成树图数据格式
                  this.treeData.r = {
                    'id': this.modelParam.id,
                    'name': this.modelParam.modelName + this.modelParam.name,
                    'type': 1,  // 1 模型  2 概念  3 属性
                    'primaryKey': null,
                    'children': []
                  }
                  this.getChilds(this.modelParam.id, datas, this.treeData.r,false);
                  this.state = 1;
                  // 清空图谱
                  d3.select('svg.tree-svg').remove();
                  // 绘制树图
                  this.treeInit();
                }
            } else {
                this.message.waring(result.msg);
            }
        }
    )
  }

  // 返回模型配置页面
  toConceptPage(){
    this.getOnlogyTreePageList();
    this.toolbarBtnClick.emit({
      state: 'toConceptPage',
    });
  }

  // 根据节点id获取节点详细信息
  getDetatilById(nodeId,type){
    if(type == 'concept'){
      let items = this.conceptData.filter(el => el.id == nodeId);
      let parent = this.conceptData.filter(el => el.id == items[0]['pid']);
      return {
        primaryKey:items[0]['primaryKey'],
        conceptId:items[0]['id'],
        conceptName:items[0]['name'],
        conceptCode:items[0]['code'],
        parentId:items[0]['pid'],
        parentName:parent[0].name,
      }
    }else{
      let items = this.attrData.filter(el => el.id == nodeId);
      let parent = this.attrData.filter(el => el.id == items[0]['pid']);
      return {
        primaryKey:items[0]['primaryKey'],
        attributeId:items[0]['id'],
        attrName:items[0]['name'],
        attrCode:items[0]['code'],
        level:items[0]['level'],
        isCompound:items[0]['isCompound'],
        parentId:items[0]['pid'],
        parentName:parent[0].name,
      }
    }
  }

  // 切换查看数据模型的方式
  changeShowStyle(){
    this.isHorizontal = !this.isHorizontal;
    setTimeout(() => {
      if(this.isHorizontal && $('#treeContainer').html()){
        const margin = {top: 0, right: 5, bottom: 0, left: 0};
        const treeWidth = $('#treeContainer').width() - margin.left - margin.right;//tree容器宽
        d3.select('.tree-svg').attr('width', treeWidth);
        // this.downloadImg()
      }
    },500);
  }
  // 下载图片
  downloadImg() {
    let getPixelRatio = function (context) { // 获取设备的PixelRatio
      let backingStore = context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio || 0.5;
      return (window.devicePixelRatio || 0.5) / backingStore;
    };
    let dataURIToBlob = function (imgName, dataURI, callback) {
      let binStr = atob(dataURI.split(',')[1]);
      let len = binStr.length;
      let arr = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      callback(imgName, new Blob([arr]));
    }
    let that = this;
    let callback = function (imgName, blob) {
      let triggerDownload = $("<a>").attr("href", URL.createObjectURL(blob)).attr("download", imgName).appendTo("body").on("click", function () {
        
      });
      triggerDownload[0].click();
      triggerDownload.remove();
    };
    // 生成的图片名称
    let imgName = "模型.png";
    let shareContent = document.getElementById("treeContainer");
    let width = 1000;
    let height = 2000;
    let canvas = document.createElement("canvas");
    let context = canvas.getContext('2d');
    let scale = getPixelRatio(context);
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    context.scale(scale, scale);

    let opts = {
      // scale: scale,
      allowTaint: true,
      useCORS: true,
      canvas: canvas,
      width: width,
      height: 2000,
      dpi: window.devicePixelRatio,
      scrollY: 0,
      scrollX: 0
    };
    html2canvas(shareContent, opts).then(function (canvas) {
      context.imageSmoothingEnabled = false;
      // context.webkitImageSmoothingEnabled = false;
      // context.msImageSmoothingEnabled = false;
      let dataUrl = canvas.toDataURL('image/png', 1.0);
      dataURIToBlob(imgName, dataUrl, callback);
    });
  }
}
